import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { FiStateChangeService } from '@fi-shared/fi-state-proxy/fi-state-change.service';
import { FiStateSrefModule } from '@fi-shared/fi-state-proxy/state-sref/state-sref.module';
import { FiAbstractStateComponent } from '@fi-shared/fi-state-proxy/fi-abstract-state.component';
import { UIRouterModule } from '@uirouter/angular';

@NgModule({
    imports: [CommonModule, FiStateSrefModule, UIRouterModule],
    declarations: [FiAbstractStateComponent],
    providers: [FiStateService, FiStateChangeService],
    exports: [FiStateSrefModule],
})
export class FiStateProxyModule {}
